import React from 'react';
import styled from "styled-components";
import ConvertPixelToRem from "@helpers/convert.rem";
import RadiusGenerate from "@helpers/radius.generate";
import {isEmpty} from "@helpers/helpers";

function CheckboxListGroup({itemKey, name, value, title, show, icon, checked, onChange, className, children}) {

    return (
        <CheckboxGroupBox key={itemKey ?? ''} className={(className ? className : '') + ((isEmpty(show) || show) ? ' show ' : '')}>
            <CheckboxInput id={value + name} type="checkbox" name={name} value={value} onChange={onChange} checked={(checked ? 'checked' : '')}/>
            <CheckboxGroupLabel htmlFor={value + name} className="d-flex justify-content-center align-items-center">
                {
                    (!isEmpty(icon)) ?
                        <CheckboxIcon>{icon}</CheckboxIcon>
                        : ''
                }
                <CheckboxLabelTitle>
                    {title}
                </CheckboxLabelTitle>

                {children}
            </CheckboxGroupLabel>
        </CheckboxGroupBox>
    )
}

export default CheckboxListGroup;


export const CheckboxGroupLabel = styled.label`
    flex-direction: column;
    margin: 0;
    color: ${props => props.theme.black};
    font-size: ${ConvertPixelToRem(14)};
    border: solid 1px ${props => props.theme.gray200};
    ${RadiusGenerate('8px')};
    background-color: ${props => props.theme.white};
    text-align: center;
    font-weight: 400;
    white-space: nowrap;
    letter-spacing: normal;
    line-height: 1.79;
    cursor: pointer;
`;

export const CheckboxInput = styled.input`
    visibility: hidden;
    display: none;
    
    &:checked+${CheckboxGroupLabel} {
        border-color: ${props => props.theme.primary};
        color: ${props => props.theme.white};
        background-color: ${props => props.theme.primary};
        
        svg {
            path, line, polygon, g {
                stroke: ${props => props.theme.white};
            }
        }
    }
`;

export const CheckboxGroupBox = styled.div`
    display: none;
    
    &.show {
        display: block;
    }
    
    &:last-child ${CheckboxGroupLabel} {
        margin-left: 0 !important;
    }
`;

export const CheckboxLabelTitle = styled.span`
    
`;

const CheckboxIcon = styled.span`
    line-height: 0;
    
    svg,img {
        width:24px;
        height:24px
    }
`;
